import {Command} from "commander";
import path from "path";

// TODO: get from keys in production
const cfg = {
    client: 'mysql2',
    connection: {
        host : process.env.DB_HOST,
        user : process.env.DB_USER,
        password : process.env.DB_PASSWORD,
        database : process.env.DB_DATABASE
    }
};

module.exports = function (program: Command) {
    program
        .command('migrate')
        .description('Run migration')
        .action(cmd => {
            console.log('Starting migration');
            return require('knex')(cfg).migrate.latest({
                directory: path.join(process.cwd(), 'api', 'dist', 'migrations')
            }).then(()=>console.log('Migration finished'));
        });
    program
        .command('migrate:rollback')
        .description('Rollback one migration batch')
        .action(cmd => {
            console.log('Rolling back');
            return require('knex')(cfg).migrate.rollback({
                directory: path.join(process.cwd(), 'api', 'dist', 'migrations')
            }).then(()=>console.log('Rollback finished'))
        });
}
